// Cache-bust API-uploaded images so a re-upload shows up immediately instead
// of the browser serving a stale cached copy of the same URL. The timestamp
// is memoized per raw URL so repeated calls (e.g. on every render) return the
// same string instead of forcing an <img>/background-image to reload on every
// render — only a genuinely new URL (a real re-upload) gets a fresh timestamp.
const timestampedUrlCache = new Map();

export function getCacheBustedUrl(url) {
	if (!url) return url;
	if (!timestampedUrlCache.has(url)) {
		timestampedUrlCache.set(url, `${url}${url.includes('?') ? '&' : '?'}time=${Date.now()}`);
	}
	return timestampedUrlCache.get(url);
}
